interface JsonLdProps {
  data: Record<string, unknown>;
}

/** 注入单个 JSON-LD 结构化数据脚本 */
export default function JsonLd({ data }: JsonLdProps) {
  const json = JSON.stringify(data);
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
}